/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import SparkMD5 from 'spark-md5';

import { Editor } from './Editor';
import { Storage } from './Storage';

export class BrowserStorageEditor implements Editor {
    private mBrowserStorage: any;

    private mData: { [key: string]: [value: any] } | Object;

    private mDataHash: string;

    private mName: string;

    public constructor(name: string, isLocalStorage: boolean = false) {
        this.mName = name;

        if (isLocalStorage) {
            this.mBrowserStorage = Storage.getInstance();
        } else {
            // TODO: We need to improve the implementaion of session storage (limit is 5MB) so that
            // we will never end up in out of memory issue.
            this.mBrowserStorage = Storage.getInstance(Storage.StorageType.SESSION_STORAGE);
        }

        const oStoredData = this.mBrowserStorage.getItem(this.mName);
        this.mData = oStoredData || {};
        this.mDataHash = SparkMD5.hash(JSON.stringify(this.mData));
    }

    /**
     * @inheritdoc
     */
    public async apply() {
        this.commit();
    }

    /**
     * @inheritdoc
     */
    public clear(): void {
        this.mData = {};
    }

    /**
     * @inheritdoc
     */
    public commit(): void {
        const newDataHash = SparkMD5.hash(JSON.stringify(this.mData));
        if (newDataHash === this.mDataHash) return;

        if (Object.keys(this.mData).length === 0) {
            this.mBrowserStorage.removeItem(this.mName);
            return;
        }

        this.mBrowserStorage.setItem(this.mName, this.mData);
    }

    /**
     * @inheritdoc
     */
    public putBoolean(key: string, value: boolean): void {
        this.mData[key] = value;
    }

    /**
     * @inheritdoc
     */
    public putJson(key: string, value: JSON): void {
        this.mData[key] = value;
    }

    /**
     * @inheritdoc
     */
    public putNumber(key: string, value: number): void {
        this.mData[key] = value;
    }

    /**
     * @inheritdoc
     */
    public putString(key: string, value: string): void {
        this.mData[key] = value;
    }

    /**
     * @inheritdoc
     */
    public remove(key: string): void {
        if (key in this.mData) {
            delete this.mData[key];
        }
    }
}
